import { render, staticRenderFns } from "./renewRecord.vue?vue&type=template&id=15f42958&scoped=true"
import script from "./renewRecord.vue?vue&type=script&lang=js"
export * from "./renewRecord.vue?vue&type=script&lang=js"
import style0 from "./renewRecord.vue?vue&type=style&index=0&id=15f42958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f42958",
  null
  
)

export default component.exports